export const platformGroupsRoutes = {
  list: "",
  create: "new",
  edit: ":id/edit",
} as const;
